import React from "react";
import { SmallNoPaddingIconButton } from "../ButtonWithIcon";
import MaterialThreeDotMenu from "../MaterialThreeDotMenu";
import { ActionIcon } from "@mantine/core";
import FavoriteStar from "../FavoriteStar";
import ButtonWithPopoverFeedback from "../ButtonWithPopoverFeedback";
import {
	IconCopy,
	IconLogout,
	IconFileShredder,
	IconTrash,
	IconTrashOff,
	IconUserEdit,
	IconArchive,
	IconArchiveOff,
	IconArrowRight,
} from "@tabler/icons-react";
import {
	LexWorkplaceArchiveIcon,
	LexWorkplaceTrashIcon,
} from "../LexWorkplaceIcons";

function InteractiveTableCell(props) {
	return (
		<div
			className="InteractiveTableCell"
			style={{
				display: "flex",
				alignItems: "center",
				width: "100%",
			}}
		>
			<div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
				{props.iconComponent ? props.iconComponent : null}
				<span>{props.children}</span>
			</div>

			<div
				style={{
					position: "relative",
					marginLeft: "auto",
					display: "flex",
					gap: 8,
				}}
			>
				{props.copyButtonValue ? (
					<div className="TableButton">
						<ButtonWithPopoverFeedback
							iconComponent={
								<IconCopy size={16} style={{ marginTop: 2 }} />
							}
							onClick={() =>
								navigator.clipboard.writeText(
									props.copyButtonValue
								)
							}
							feedbackMessage="Copied to clipboard!"
							title="Copy to clipboard"
						/>
					</div>
				) : null}
				{props.otherButtons && props.otherButtons.length
					? props.otherButtons.map(
							(
								{
									iconComponent,
									onClick,
									disabled,
									disabledHoverText,
									title,
								},
								index
							) => {
								return (
									<div
										className="TableButton"
										key={index}
										title={
											disabled
												? disabledHoverText
												: title || ""
										}
									>
										<ActionIcon
											variant="subtle"
											size="sm"
											p={0}
											disabled={disabled}
											onClick={onClick}
										>
											{iconComponent
												? iconComponent
												: null}
										</ActionIcon>
									</div>
								);
							}
						)
					: null}

				{props.menuItems && props.menuItems.length > 0 && (
					<MaterialThreeDotMenu
						className="TableButton"
						menuItems={props.menuItems}
					/>
				)}
			</div>
		</div>
	);
}

const trashAndArchiveIconSizeAttribute = "lg";

function getTrashIconActionButton({
	itemLifecycleStatusObject,
	matterOrFolderLifecycleStatusObject,
	trashClickHandler,
	isCheckedOutOrInUse,
	archiveDisabled,
	archiveDisabledHoverText,
}) {
	if (matterOrFolderLifecycleStatusObject.IN_ARCHIVE) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={true}
					onClick={() => {}}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconTrash size={20} stroke={0} />
					<IconTrash size={20} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (matterOrFolderLifecycleStatusObject.IN_TRASH) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="delete"
					className="trash"
					disabled={true}
					onClick={() => {}}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconTrash size={10} stroke={0} />
					<LexWorkplaceTrashIcon />
					<IconTrash size={10} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (itemLifecycleStatusObject.IN_TRASH) {
		return (
			<span className="deletedTrashIcon">
				<SmallNoPaddingIconButton
					aria-label="delete"
					className="trash"
					disabled={false}
					onClick={trashClickHandler}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconTrash size={10} stroke={0} />
					<IconTrash className="deletedTrashIconNoHover" size={20} />
					<IconTrashOff className="deletedTrashIconHover" size={20} />
					<IconTrash size={10} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (itemLifecycleStatusObject.IN_ARCHIVE) {
		return (
			<span title={archiveDisabled ? archiveDisabledHoverText : ""}>
				<SmallNoPaddingIconButton
					aria-label="delete"
					className="trash"
					disabled={!!archiveDisabled}
					onClick={archiveDisabled ? undefined : trashClickHandler}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArrowRight className="notDeleted" size={20} />
					<IconTrash className="notDeleted" size={20} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (isCheckedOutOrInUse) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="delete"
					className="trash"
					disabled={true}
					onClick={() => {}}
				>
					<></>
				</SmallNoPaddingIconButton>
			</span>
		);
	} else {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="delete"
					className="trash"
					disabled={false}
					onClick={trashClickHandler}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArrowRight className="notDeleted" size={20} />
					<IconTrash className="notDeleted" size={20} />
				</SmallNoPaddingIconButton>
			</span>
		);
	}
}
const actionSlotStyle = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

function getArchiveIconActionButton({
	itemLifecycleStatusObject,
	matterOrFolderLifecycleStatusObject,
	isCheckedOutOrInUse,
	archiveClickHandler,
	archiveDisabled,
	archiveDisabledHoverText,
}) {
	if (matterOrFolderLifecycleStatusObject.IN_TRASH) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={true}
					onClick={() => console.log("no op")}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArchive size={20} stroke={0} />
					<IconArchive size={20} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (matterOrFolderLifecycleStatusObject.IN_ARCHIVE) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={true}
					onClick={() => console.log("no op")}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArchive size={10} stroke={0} />
					<LexWorkplaceArchiveIcon />
					<IconArchive size={10} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (itemLifecycleStatusObject.IN_ARCHIVE) {
		return (
			<span
				className={"deletedTrashIcon"}
				title={archiveDisabled ? archiveDisabledHoverText : ""}
			>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={!!archiveDisabled}
					onClick={archiveDisabled ? undefined : archiveClickHandler}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArchive size={10} stroke={0} />
					<IconArchive
						className="deletedTrashIconNoHover"
						size={20}
					/>
					<IconArchiveOff
						className="deletedTrashIconHover"
						size={20}
					/>
					<IconArchiveOff stroke={0} size={10} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else if (isCheckedOutOrInUse) {
		return (
			<span>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={true}
					onClick={() => console.log("no op")}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArchive size={20} stroke={0} />
					<IconArchive size={20} stroke={0} />
				</SmallNoPaddingIconButton>
			</span>
		);
	} else {
		return (
			<span title={archiveDisabled ? archiveDisabledHoverText : ""}>
				<SmallNoPaddingIconButton
					aria-label="archive"
					className="trash"
					disabled={!!archiveDisabled}
					onClick={archiveDisabled ? undefined : archiveClickHandler}
					size={trashAndArchiveIconSizeAttribute}
				>
					<IconArrowRight className="notDeleted" size={20} />
					<IconArchive className="notDeleted" size={20} />
				</SmallNoPaddingIconButton>
			</span>
		);
	}
}
function ActionsTableCell(props) {
	return (
		<div
			style={{
				display: "grid",
				gridTemplateColumns: `repeat(${props.numColumns || 1}, auto)`,
				gap: 4,
				width: "fit-content",
			}}
		>
			{props.trashClickHandler ? (
				<div
					style={{
						...actionSlotStyle,
					}}
				>
					{getTrashIconActionButton({
						itemLifecycleStatusObject:
							props.itemLifecycleStatusObject,
						matterOrFolderLifecycleStatusObject:
							props.matterOrFolderLifecycleStatusObject,
						trashClickHandler: props.trashClickHandler,
						isCheckedOutOrInUse:
							props.isCheckedOut || props.isInUse,
						archiveDisabled: props.archiveDisabled,
						archiveDisabledHoverText:
							props.archiveDisabledHoverText,
					})}
				</div>
			) : null}
			{props.archiveClickHandler || props.archiveDisabled ? (
				<div
					style={{
						...actionSlotStyle,
					}}
				>
					{getArchiveIconActionButton({
						itemLifecycleStatusObject:
							props.itemLifecycleStatusObject,
						matterOrFolderLifecycleStatusObject:
							props.matterOrFolderLifecycleStatusObject,
						archiveClickHandler: props.archiveClickHandler,
						isCheckedOutOrInUse:
							props.isCheckedOut || props.isInUse,
						archiveDisabled: props.archiveDisabled,
						archiveDisabledHoverText:
							props.archiveDisabledHoverText,
					})}
				</div>
			) : null}
			{props.starClickHandler ? (
				<div style={actionSlotStyle}>
					<SmallNoPaddingIconButton
						aria-label="favorite"
						disabled={props.disableFavorite}
						className="favoriteStar"
						onClick={props.starClickHandler}
						size={trashAndArchiveIconSizeAttribute}
					>
						<FavoriteStar isFavorite={props.isFavorite} />
					</SmallNoPaddingIconButton>
				</div>
			) : null}

			{props.showCheckedOutSpace ? (
				<div style={actionSlotStyle}>
					{props.isCheckedOut ? (
						<IconLogout color={"var(--lxw-main-500)"} size={18} />
					) : null}
				</div>
			) : null}
			{props.showCheckedOutSpace ? (
				<div style={actionSlotStyle}>
					{props.isInUse ? (
						<IconUserEdit color={"var(--lxw-main-500)"} size={18} />
					) : null}
				</div>
			) : null}
			{props.showRestoreFromTrashPage ? (
				<div className="permanentDeleteIcon" style={actionSlotStyle}>
					<SmallNoPaddingIconButton
						aria-label="delete"
						className="trash"
						onClick={props.restoreFromTrashClickHandler}
					>
						<IconTrashOff size={20} />
					</SmallNoPaddingIconButton>
				</div>
			) : null}
			{props.showPermanentDelete ? (
				<div className="permanentDeleteIcon" style={actionSlotStyle}>
					<SmallNoPaddingIconButton
						aria-label="delete"
						className="trash"
						onClick={props.permanentDeleteClickHandler}
					>
						<IconFileShredder size={20} />
					</SmallNoPaddingIconButton>
				</div>
			) : null}
		</div>
	);
}
export default InteractiveTableCell;
export { ActionsTableCell };
